module.exports = __webpack_public_path__ + "static/media/LK_White_Billing.daf7d736.svg";